var lg_6711R1P072B_DVD = {
    name: "6711R1P072B_DVD",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,170,186,250,226],
        },
        {
            // function: "KEY_DVD",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,181,125,234,162],
        },
        {
            function: "KEY_OPEN",
            name: "KEY_OPEN",
            icon: "KEY_OPEN",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,174,235,90,226],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,187,213,106,226],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,171,235,170,226],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,183,213,170,226],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,175,214,170,226],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,191,170,170,226],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,170,171,127,98],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,181,86,191,98],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,173,86,223,98],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,186,173,95,98],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,171,86,239,98],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,173,117,186,226],
        },
        {
            function: "KEY_FORWARD",
            name: "KEY_FORWARD",
            icon: "KEY_FORWARD",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,186,234,186,226],
        },
        {
            function: "KEY_PREVIOUS",
            name: "KEY_PREVIOUS",
            icon: "KEY_PREVIOUS",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,182,234,218,226],
        },
        {
            function: "KEY_NEXT",
            name: "KEY_NEXT",
            icon: "KEY_NEXT",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,171,117,218,226],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,170,245,234,226],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,181,117,122,226],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,181,234,234,226],
        },
        {
            function: "display",
            name: "display",
            icon: "display",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,173,235,106,226],
        },
        {
            function: "KEY_SETUP",
            name: "KEY_SETUP",
            icon: "KEY_SETUP",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,174,219,91,98],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,181,218,235,98],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,173,219,107,98],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,189,90,175,98],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,170,214,247,98],
        },
        {
            // function: "KEY_ENTER",
            function: "KEY_OK",
            name: "KEY_OK",
            icon: "KEY_OK",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,182,173,111,98],
        },
        {
            function: "disc-menu",
            name: "disc-menu",
            icon: "disc-menu",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,187,90,183,98],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,190,181,87,98],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,170,182,251,98],
        },
        {
            function: "KEY_ANGLE",
            name: "KEY_ANGLE",
            icon: "KEY_ANGLE",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,171,173,215,98],
        },
        {
            function: "KEY_ZOOM",
            name: "KEY_ZOOM",
            icon: "KEY_ZOOM",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,171,93,221,98],
        },
        {
            function: "KEY_TITLE",
            name: "KEY_TITLE",
            icon: "KEY_TITLE",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,173,173,183,98],
        },
        {
            function: "program",
            name: "program",
            icon: "program",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,189,181,91,98],
        },
        {
            function: "a-b",
            name: "a-b",
            icon: "a-b",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,181,93,125,98],
        },
        {
            function: "random",
            name: "random",
            icon: "random",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,173,93,189,98],
        },
        {
            function: "KEY_CLEAR",
            name: "KEY_CLEAR",
            icon: "KEY_CLEAR",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,174,173,175,98],
        },
        {
            function: "KEY_AGAIN",
            name: "KEY_AGAIN",
            icon: "KEY_AGAIN",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,186,218,187,98],
        },
        {
            function: "lp",
            name: "lp",
            icon: "lp",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,182,218,219,98],
        },
        {
            function: "cm-skip",
            name: "cm-skip",
            icon: "cm-skip",
            command: [68,0,4,115,2,73,6,115,2,236,1,226,17,46,17,115,2,229,173,55,107,118,181,109,123,98],
        },
    ]
}
export default lg_6711R1P072B_DVD